import * as swcHelpers from '@swc/helpers';
import { Util } from '@grandvisionhq/forms';
import { createImageUrl } from '../../Orders/mappers/view/utils/create-image-url.js';

/** Map raw data to PersonalDetails model of type Record<string, string>
 *
 * Defaults to an empty string if key null | undefined
 */ const toPersonalDetails = (raw)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    return {
        dateOfBirth: (ref = raw === null || raw === void 0 ? void 0 : raw.dateOfBirth) !== null && ref !== void 0 ? ref : '',
        firstName: (ref1 = raw === null || raw === void 0 ? void 0 : raw.firstName) !== null && ref1 !== void 0 ? ref1 : '',
        lastName: (ref2 = raw === null || raw === void 0 ? void 0 : raw.lastName) !== null && ref2 !== void 0 ? ref2 : '',
        middleName: (ref3 = raw === null || raw === void 0 ? void 0 : raw.middleName) !== null && ref3 !== void 0 ? ref3 : '',
        phone: (ref4 = raw === null || raw === void 0 ? void 0 : raw.phone) !== null && ref4 !== void 0 ? ref4 : '',
        salutation: (ref5 = raw === null || raw === void 0 ? void 0 : raw.salutation) !== null && ref5 !== void 0 ? ref5 : '',
        ssn: (ref6 = raw === null || raw === void 0 ? void 0 : raw.ssn) !== null && ref6 !== void 0 ? ref6 : '',
        preferredGlobalStoreId: ''
    };
};
/** Known GraphQL schema keys for Types.PersonalDetailsB2CUpdateInput interface
 * `Required` for typesafety if schema interface ever updates
 */ const personalDetailsSchemaKeys = {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    middleName: '',
    salutation: '',
    phone: '',
    ssn: '',
    billingAddress: null,
    shippingAddress: null,
    preferredStore: null,
    preferredGlobalStoreId: null
};
const mapFormStateToPersonalDetailsType = (formState)=>{
    const personalData = Object.entries(formState).reduce((result, [fieldName, fieldState])=>{
        // This applies for the old DateOfBirth component, which BeNe still uses unfortunately.
        // It gives back a ddmmyyyy string, which we have to parse to YYYY-MM-DD
        if (fieldName === 'dateOfBirth' && (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value)) {
            if (/^-?\d+$/.exec(fieldState === null || fieldState === void 0 ? void 0 : fieldState.value)) {
                const day = fieldState.value.slice(0, 2);
                const month = fieldState.value.slice(2, 4);
                const year = fieldState.value.slice(4, 8);
                return swcHelpers.objectSpread({}, result, {
                    dateOfBirth: [
                        year,
                        month,
                        day
                    ].join('-')
                });
            }
            // If it's not the old DateOfBirth component, we're using DateOfBirthSelect, we can return it normally
            return swcHelpers.objectSpread({}, result, {
                dateOfBirth: Util.toStandardDateFormat(fieldState === null || fieldState === void 0 ? void 0 : fieldState.value)
            });
        }
        /** The customerDateOfBirth will be returned if present since this returns the value from the form, the back-end expects this in YYYY-MM-DD */ if (fieldName === 'customerDateOfBirth' && !!(fieldState === null || fieldState === void 0 ? void 0 : fieldState.value)) {
            return swcHelpers.objectSpread({}, result, {
                dateOfBirth: Util.toStandardDateFormat(fieldState.value)
            });
        }
        if (!(fieldName in personalDetailsSchemaKeys)) {
            return result;
        }
        return swcHelpers.objectSpread({}, result, {
            [fieldName]: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) || null
        });
    }, {});
    return personalData;
};
const toBillingAddress = (raw)=>{
    var ref, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    return {
        additionalStreetInfo: (ref = raw === null || raw === void 0 ? void 0 : raw.additionalStreetInfo) !== null && ref !== void 0 ? ref : '',
        additionalAddressInfo: (ref7 = raw === null || raw === void 0 ? void 0 : raw.additionalAddressInfo) !== null && ref7 !== void 0 ? ref7 : '',
        city: (ref8 = raw === null || raw === void 0 ? void 0 : raw.city) !== null && ref8 !== void 0 ? ref8 : '',
        company: (ref9 = raw === null || raw === void 0 ? void 0 : raw.company) !== null && ref9 !== void 0 ? ref9 : '',
        country: (ref10 = raw === null || raw === void 0 ? void 0 : raw.country) !== null && ref10 !== void 0 ? ref10 : '',
        postalCode: (ref11 = raw === null || raw === void 0 ? void 0 : raw.postalCode) !== null && ref11 !== void 0 ? ref11 : '',
        prefix: (ref12 = raw === null || raw === void 0 ? void 0 : raw.prefix) !== null && ref12 !== void 0 ? ref12 : '',
        region: (ref13 = raw === null || raw === void 0 ? void 0 : raw.region) !== null && ref13 !== void 0 ? ref13 : '',
        streetName: (ref14 = raw === null || raw === void 0 ? void 0 : raw.streetName) !== null && ref14 !== void 0 ? ref14 : '',
        streetNumber: (ref15 = raw === null || raw === void 0 ? void 0 : raw.streetNumber) !== null && ref15 !== void 0 ? ref15 : '',
        firstName: (ref16 = raw === null || raw === void 0 ? void 0 : raw.firstName) !== null && ref16 !== void 0 ? ref16 : '',
        lastName: (ref17 = raw === null || raw === void 0 ? void 0 : raw.lastName) !== null && ref17 !== void 0 ? ref17 : '',
        middleName: (ref18 = raw === null || raw === void 0 ? void 0 : raw.middleName) !== null && ref18 !== void 0 ? ref18 : '',
        salutation: (ref19 = raw === null || raw === void 0 ? void 0 : raw.salutation) !== null && ref19 !== void 0 ? ref19 : ''
    };
};
/** Known GraphQL schema keys for Types.CustomerAddressInput interface
 * `Required` for typesafety if schema interface ever updates
 */ const billingAddressSchemaKeys = {
    additionalStreetInfo: '',
    additionalAddressInfo: '',
    city: '',
    firstName: '',
    lastName: '',
    postalCode: '',
    region: '',
    salutation: '',
    streetName: '',
    streetNumber: '',
    middleName: '',
    country: '',
    company: '',
    prefix: ''
};
const mapFormStateToBillingAddressType = (formState)=>{
    const billingAddress = Object.entries(formState).reduce((result, [fieldName, fieldState])=>{
        if (!(fieldName in billingAddressSchemaKeys)) {
            return result;
        }
        return swcHelpers.objectSpread({}, result, {
            [fieldName]: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) || null
        });
    }, {});
    return billingAddress;
};
const toPreferredStore = (raw)=>{
    if (raw === null || raw === void 0 ? void 0 : raw.globalStoreId) {
        return {
            globalStoreId: raw.globalStoreId
        };
    }
    return null;
};
const toRecentOrders = (raw)=>{
    return raw === null || raw === void 0 ? void 0 : raw.map(({ lineItems , orderDate , orderNumber , paymentStatus  })=>{
        const lineItem = lineItems[0];
        let additionalOrderFields = {
            orderImageAlt: '',
            orderImageUrl: ''
        };
        switch(lineItem === null || lineItem === void 0 ? void 0 : lineItem.__typename){
            case 'OrderLineItemBundle':
            case 'OrderLineItemContactLens':
            case 'OrderLineItemRegular':
            case 'OrderLineItemSolution':
                var ref;
                var ref20;
                additionalOrderFields = {
                    orderImageUrl: createImageUrl(lineItem.product.mainImage),
                    orderImageAlt: (ref20 = (ref = lineItem.product.name[0]) === null || ref === void 0 ? void 0 : ref.value) !== null && ref20 !== void 0 ? ref20 : ''
                };
                break;
            case 'OrderLineItemPrescriptionGlass':
            case 'OrderLineItemNonPrescriptionBundle':
                var ref21;
                var ref22;
                additionalOrderFields = {
                    orderImageUrl: createImageUrl(lineItem.mainLineItem.product.mainImage),
                    orderImageAlt: (ref22 = (ref21 = lineItem.mainLineItem.product.name[0]) === null || ref21 === void 0 ? void 0 : ref21.value) !== null && ref22 !== void 0 ? ref22 : ''
                };
                break;
            case 'OrderLineItemSubscription':
                var ref23, ref24, ref25, ref26, ref27, ref28;
                var ref29;
                additionalOrderFields = {
                    orderImageUrl: createImageUrl((ref23 = lineItem.subscriptionLineItems) === null || ref23 === void 0 ? void 0 : (ref24 = ref23[0]) === null || ref24 === void 0 ? void 0 : ref24.product.mainImage),
                    orderImageAlt: (ref29 = (ref27 = (ref25 = lineItem.subscriptionLineItems) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[0]) === null || ref26 === void 0 ? void 0 : ref26.product.name) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[0]) === null || ref28 === void 0 ? void 0 : ref28.value) !== null && ref29 !== void 0 ? ref29 : ''
                };
        }
        const recentOrder = swcHelpers.objectSpread({
            orderDate,
            orderNumber,
            paymentStatus: paymentStatus !== null && paymentStatus !== void 0 ? paymentStatus : ''
        }, additionalOrderFields);
        return recentOrder;
    });
};

export { mapFormStateToBillingAddressType, mapFormStateToPersonalDetailsType, toBillingAddress, toPersonalDetails, toPreferredStore, toRecentOrders };
//# sourceMappingURL=profile.js.map
